import React, { Component } from 'react';

import ConnectedAddress from './ConnectedAddress';

const LocalizedAddress = (WrappedComponent) => {
    return class LocalizedAddress extends Component {

        render() {
            let childProps = {...this.props};
            if(childProps.country === "") {
                childProps.country = "";
            }

            return(
                <WrappedComponent {...childProps} />
            )
        }
    }
}

LocalizedAddress.defaultProps = {
    country: 'US'
}

export default LocalizedAddress(ConnectedAddress);
